
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../App.styles";
import Modal from "./Modal";
import Textarea from "./Textarea";
import Spinner from "./Spinner";

const ModalGeneratePhoto = ({ onDismiss, show, loading, createAiPhoto }) => {
    const { t } = useTranslation()
    const [modalValue, setModalValue] = useState({ prompt: '' })
    const onSave = async e => {
        e.preventDefault()
        const { prompt } = modalValue
        await createAiPhoto(prompt)
        handleDismiss()
    }
    const handleDismiss = () => {
        // Clear the prompt value
        setModalValue({ prompt: '' })
        // Close the modal
        onDismiss()
    }

    return (
        <Modal onDismiss={handleDismiss} show={show} size="lg" className="modal--html form-clean">
            <div className="modal-title px-3 py-2">
                <span dangerouslySetInnerHTML={{ __html: t('AI generated photo') }} />
            </div>
            <div className="modal-body px-3 pb-3">
                <p dangerouslySetInnerHTML={{
                    __html: t(`Ask our AI to create a photo for your game/challenge. 
                Tell it what to create. For example, "A photo of a dog wearing a sombrero."`)
                }} />
                <Textarea
                    name="prompt"
                    useQuery={() => [modalValue, setModalValue]}
                    mode="clean"
                    rows="5"
                    disabled={loading}
                />
            </div>
            <div className="modal-footer">
                {
                    !loading && (
                        <Button disabled={loading} className="btn--flat" data-dismiss="modal" onClick={handleDismiss} outline>
                            {t('Cancel')}
                        </Button>
                    )
                }
                <Button disabled={loading} className="btn--flat" data-dismiss="modal" onClick={onSave} color="primary">
                    {t('Generate Photo')} {loading ? <Spinner size="0.875rem" /> : null}
                </Button>
            </div>
        </Modal>
    )
}

export default ModalGeneratePhoto